import { css } from "@emotion/react";

export const containerStyle = css`
  @media only screen and (max-width: 992px) {
    position: fixed;
    right: 0;
    z-index: 1;
    height: 100vh;
  }
`;

export const headerStyle = css`
  @media only screen and (min-width: 992px) {
    display: none;
  }

  @media screen and (width: 992px) {
    display: block;
  }

  background-color: #000000;
  position: fixed;
  z-index: 2;
  width: 100%;
  padding-top: 0;
`;

export const layoutStyle = css`
  min-height: 100vh;
`;
